export const ADMIN_USER_ICON = 'fas fa-user-shield'
export const ADMIN_USER_ICON_COLOR = 'primary'
export const NON_ADMIN_USER_ICON = 'fas fa-user'
export const NON_ADMIN_USER_ICON_COLOR = 'textLight'

export const PRIMARY_CONTACT_ICON = 'fas fa-user-check'
export const PRIMARY_CONTACT_ICON_COLOR = 'primary'
export const NON_PRIMARY_CONTACT_ICON = 'fas fa-user-minus'
export const NON_PRIMARY_CONTACT_ICON_COLOR = 'textLight'
